import React from "react";
import { Link } from "react-router";
import arrowBack from "../../assets/img/arrow-back-blue.png";

const RequestToJoinGroup = () => {
  return (
    <div className="site--width">
      <Link
        to="/groups/my"
        style={{
          display: "flex",
          alignItems: "center",
          gap: 12,
          marginLeft: 12,
          marginTop: 24,
        }}
      >
        <img
          style={{ width: 24, height: 24 }}
          src={arrowBack}
          alt="arrow-back"
        />
        <div
          style={{
            textDecoration: "underline",
            textDecorationColor: "#039be5",
          }}
        >
          Return to MedMeetings
        </div>
      </Link>
      <div className="become-superhost">
        <h2>Request To Join</h2>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 8,
            fontSize: 18,
            marginTop: 40,
            textAlign: "center",
          }}
        >
          <div>If you would like to join a MedMeetings group,</div>
          <div>
            please contact us at{" "}
            <a href="mailto:support@medcafe.ie">support@medcafe.ie</a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RequestToJoinGroup;



// WEBPACK FOOTER //
// ./src/containers/RequestToJoinGroup/index.jsx